import { memo, useEffect, useRef } from 'react';

import { LOCAL_STORAGE_KEYS } from 'features/exam/constants';

import { AuthenticationScheme } from '../constants';
import { useAuthentication } from '../hooks';

export const SignOut = memo(() => {
  const { activeScheme, logoutOidc, logoutShare } = useAuthentication();
  const isExecutedRef = useRef(false);

  useEffect(() => {
    // Do not logout if we already have, or if the authentication layer has not initialized yet.
    if (isExecutedRef.current || activeScheme == null) return;

    localStorage.removeItem(LOCAL_STORAGE_KEYS.EXAM_GRID_STATE);

    if (activeScheme === AuthenticationScheme.OIDC) {
      logoutOidc();
    } else if (activeScheme === AuthenticationScheme.SHARE) {
      logoutShare();
    }

    isExecutedRef.current = true;
  }, [activeScheme, logoutOidc, logoutShare]);

  return null;
});

SignOut.displayName = 'SignOut'; // Added display name for better debugging
